export default __webpack_public_path__ + "static/media/animated_logo1.3618d910.gif";